import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  OverTimeSegmentedVizData,
  OverTimeSegmentedVizExternalProps,
} from '../../types';
import { overTimeSegmentedBarChartDataToUiComponentProps } from './dataToUiComponentProps';
import {
  OverTimeSegmentedBarChartActions,
  OverTimeSegmentedBarChartState,
  OverTimeSegmentedBarChartUiComponentProps,
} from './types';
import { OverTimeSegmentedBarChartUiComponent } from './UiComponent';

import { useOverTimeSegmentedBarChartStateManager } from './useStateManager';

export const overTimeSegmentedBarChartViewConfig: DataVizContainerViewConfigWithStateManager<
  OverTimeSegmentedVizData,
  OverTimeSegmentedVizExternalProps,
  OverTimeSegmentedBarChartUiComponentProps,
  OverTimeSegmentedBarChartState,
  OverTimeSegmentedBarChartActions
> = {
  hasStateManager: true,
  useStateManager: useOverTimeSegmentedBarChartStateManager,
  dataToUiComponentProps: overTimeSegmentedBarChartDataToUiComponentProps,
  UiComponent: OverTimeSegmentedBarChartUiComponent,
};
